import React from 'react';
import DialogContentMUI from '@material-ui/core/DialogContent';
import { DialogContentProps } from '@material-ui/core';

export const DialogContent: React.FC<DialogContentProps> = ({ children, ...rest }) => {
	return <DialogContentMUI {...rest}>{children}</DialogContentMUI>;
};
